import React, { useState, useEffect } from 'react';
import './Steps.css';

function Step5({ onNext }) {
  const [stage, setStage] = useState(0);
  const stages = [
    'Processing request…',
    'Checking loyalty…',
    'Checking cuteness…',
    'Checking compatibility…'
  ];

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 1000),
      setTimeout(() => setStage(2), 2000),
      setTimeout(() => setStage(3), 3000),
      setTimeout(() => setStage(4), 4000)
    ];

    return () => timers.forEach(timer => clearTimeout(timer));
  }, []);

  return (
    <div className="step-container">
      <div className="step-content">
        <div className="emoji-large">💌</div>
        <h1 className="step-title">Step 5 – Authorization Process</h1>
        <h2 className="heading">🛡 Granting Lifetime Access…</h2>
        
        <div className="loading-section">
          {stage >= 0 && <p className="loading-text">{stages[0]}</p>}
          {stage >= 1 && <p className="loading-text">{stages[1]}</p>}
          {stage >= 2 && <p className="loading-text">{stages[2]}</p>}
          {stage >= 3 && <p className="loading-text">{stages[3]}</p>}
        </div>

        {stage >= 4 && (
          <>
            <div className="result-box success">
              <p className="result-text">"All conditions passed successfully."</p>
            </div>
            <button className="btn btn-primary" onClick={onNext}>
              🔓 Unlock Heart
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Step5;